export const TEAM_EMOJIS = [
  "😀",
  "😁",
  "😂",
  "🤣",
  "😊",
  "😉",
  "😍",
  "😘",
  "😎",
  "🤔",
  "😅",
  "😇",
  "🙂",
  "🙃",
  "😮",
  "😢",
  "😭",
  "😡",
  "👍",
  "👎",
  "👏",
  "🙌",
  "🎉",
  "❤️",
  "💯",
] as const;

export const IMAGE_EXTENSIONS = new Set([
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "bmp",
  "svg",
]);

export const AUDIO_EXTENSIONS = new Set([
  "mp3",
  "wav",
  "m4a",
  "ogg",
  "aac",
  "flac",
]);

export const MESSAGE_PAGE_SIZE = 25;
